import { Directive, input, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[appTemplateFor]'
})
export class TemplateForDirective {
  templateRef = inject(TemplateRef);

  appTemplateFor = input.required<string>();
}